export default "__VITE_ASSET__CaldwXKS__"